<template>
  <div class="detail_mobile">
    <div class="detailBack">
      <img
        src="../../public/statics/img/mobile/icon_return.png"
        alt=""
        @click="backto"
      />
      <span class="dec">商品详情</span>
    </div>
    <div class="detailBanner">
      <div style="margin: 0 auto; width: 90%">
        <swiper>
          <swiper-slide
            v-for="(item, index) in shopDetail.slider_image"
            :key="index"
          >
            <img :src="item" alt="" style="height: 18rem; max-width: 20rem" />
            <div class="swiper-pagination"></div>
            <div class="page">
              <span>{{ index + 1 }}/{{ shopDetail.slider_image.length }}</span>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="detailPrice">
      <div class="price-top">
        <div class="price-top-left">
          {{ shopDetail.goods_name }}
        </div>
        <div class="price-top-right" v-if="shopDetail.is_collect == 0">
          <img
            src="../../public/statics/img/mobile/xin3.png"
            alt=""
            v-preventClick
            @click="shoucang(shopDetail.is_collect)"
          />
          收藏
        </div>
        <div class="price-top-right" v-if="shopDetail.is_collect == 1">
          <img
            src="../../public/statics/img/mobile/xin2.png"
            alt=""
            v-preventClick
            @click="shoucang(shopDetail.is_collect)"
          />
          收藏
        </div>
      </div>
      <div class="price-center">
        <div class="price">￥{{ shopDetail.price }}</div>
        <!-- <div></div> -->
        <div>{{ shopDetail.start_order }}</div>
      </div>
    </div>
    <div class="detailDec">
      <div>品牌名称：{{ shopDetail.goods_brand }}</div>
      <div>商品型号：{{ shopDetail.goods_model }}</div>
      <!-- <div>订货编码：{{ shopDetail.goods_no }}</div> -->
    </div>
    <div class="detailRule">
      <div class="rule">
        <div>规格</div>
        <div class="cartgroy">
          共<span>{{ shopDetail.productValue.length }}</span
          >种
        </div>
        <div class="ruleImg" @click="opendraw">
          <span>切换规格</span>
          <img src="../../public/statics/img/mobile/qie.png" alt="" />
        </div>
      </div>
    </div>
    <div class="detailPhoto">
      <div class="photo-dec">产品介绍</div>
      <div class="photo-img" v-html="shopDetail.content"></div>
    </div>
    <div class="joinCar">
      <div class="Car-left">
        <div @click="tocar">
          <img src="../../public/statics/img/mobile/car.png" alt="" />
          <div>购物车</div>
        </div>
        <div @click="todetail">
          <img src="../../public/statics/img/mobile/xin.png" alt="" />
          <div>我的收藏</div>
        </div>
      </div>
      <div class="Car-center">
        <el-input-number
          v-model="num"
          @change="handleChange"
          :min="1"
          label="描述文字"
        ></el-input-number>
      </div>
      <div class="Car-right" @click="addCar">加入购物车</div>
    </div>
    <van-popup
      v-model="show"
      position="bottom"
      class="popup"
      :style="{ height: '70%', borderRadius: '5% 5% 0 0' }"
    >
      <div class="popup-top">
        <div class="top-left">
          <img :src="details.image" alt="" />
        </div>
        <div class="top-right">
          <div class="right1">
            {{ details.suk }}
          </div>
          <div class="right2">￥{{ details.price }}</div>
          <!-- <div class="right3">订货编码：TY9703</div> -->
        </div>
      </div>
      <div class="popup-center">
        <div class="center-title">套餐</div>
        <div class="center-content">
          <div
            v-for="(item, index) in shopDetail.productValue"
            :key="index"
            :class="indexs == index ? 'dec1  center-dec' : ' center-dec'"
            @click="changesuk(index, item.unique)"
          >
            <img :src="item.image" alt="" />
            <span>{{ item.suk }}</span>
          </div>
        </div>
      </div>
      <div class="popup-bottom" @click="confirm">
        <div>确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import { auth, anth } from "../request/api";
import Swiper from "swiper";
import "../../public/statics/css/base.css";
import "swiper/dist/css/swiper.css";
export default {
  name: "index_mobile",
  data() {
    return {
      topshow: true,
      newdata: [],
      show: false,
      num: "1",
      isshoucang: 1,
      shopId: "",
      imgList: [],
      shopDetail: {},
      indexs: 0,
      unique: "",
      details: {},
    };
  },
  watch: {},
  components: {},
  created() {
    this.shopId = this.$route.query.id;
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollx, true);
    this.getDetail();
    document.body.scrollTop = -85;
    document.documentElement.scrollTop = -85;
    console.log(this.$route.query);
    // this._initSwiper();
    this.myswiper();
  },
  methods: {
    myswiper: function() {
				var swiper = new Swiper('.swiper-container', {
					pagination: {
						el: '.swiper-pagination',
					},
				});
			},

    changesuk(e, unique) {
      this.indexs = e;
      this.unique = unique;
      this.details = this.shopDetail.productValue[e];
    },
    confirm() {
      this.show = false;
    },
    getDetail() {
      let url = "/v1/shop/goods/show";
      let data = {
        id: this.shopId,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          // console.log(res);
          this.shopDetail = res.data.data;
          this.unique = res.data.data.productValue[0].unique;
          this.details = res.data.data.productValue[0];
        }else{
            Toast({
              message: res.data.msg,
              position: "center",
            });
        }
      });
    },
    handleScrollx() {
      if (window.pageYOffset > 85) {
        this.topshow = false;
      } else {
        this.topshow = true;
      }
    },
    tocar() {
           let url = "/v1/shop/my/cart";
      let data = {
        // page: 1,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$router.push({
            path: "/shoucang_mobile",
            query: {
              types: 1,
            },
          });
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    addCar() {
      let url = "/v1/shop/my/addCart";
      let data = {
        id: this.shopId,
        product_attr_unique: this.unique,
        num: this.num,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          Toast({
            message: "添加成功",
            position: "center",
          });
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    todetail() {
       let url = "/v1/shop/my/cart";
      let data = {
        // page: 1,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$router.push({
            path: "/shoucang_mobile",
            query: {
              types: 2,
            },
          });
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    backto() {
      this.$router.push({
        path: "/shop_mobile",
      });
    },
    shoucang(isc) {
      // console.log(this.isshoucang);
      // if (this.isshoucang === 1) {
      //   Toast({
      //     message: "收藏成功",
      //     position: "center",
      //   });
      //   this.isshoucang = 2;
      // }
      // if (this.isshoucang === 2) {
      //   Toast({
      //     message: "取消收藏",
      //     position: "center",
      //   });
      //   this.isshoucang = 1;
      // }
      let url = "";
      if (isc == 0) {
        url = "/v1/shop/my/addCollect";
      } else {
        url = "/v1/shop/my/delCollect";
      }
      let data = {
        id: this.shopId,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          if (isc == 0) {
            Toast({
              message: "收藏成功",
              position: "center",
            });
          } else if (isc == 1) {
            Toast({
              message: "取消收藏",
              position: "center",
            });
          }

          this.getDetail();
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
          });
        }
      });
    },
    opendraw() {
      this.show = true;
    },
    handleChange() {},
  },
};
</script>

<style scoped lang='scss'>
.detail_mobile {
  width: 100%;
  // height: 100vh;
  background-color: rgba(244, 244, 244, 1);
  .detailBack {
    width: 100%;
    background-color: #fff;
    height: 3rem;
    padding: 1rem 1rem;
    font-size: 1.3rem;
    font-family: PingFang SC;
    line-height: 2rem;
    color: #333333;
    opacity: 1;
    display: flex;
    justify-content: start;
    align-items: center;
    box-sizing: border-box;
    img {
      width: 1.5rem;
      height: 1.5rem;
    }
    .dec {
      width: 90%;
      font-family: PingFang SC;
      font-weight: bold;
    }
  }
  .detailBanner {
    background-color: #fff;
    // height: 5rem;
    border-top: 1px solid rgba(112, 112, 112, 0.1);
    padding-top: 2rem;
    .page {
      // width: 29px;
      // height: 14px;
      margin: 1rem auto;
      width: 20rem;
      display: flex;
      justify-content: flex-end;
      span {
        width: 2rem;
        height: 1.5rem;
        line-height: 1.5rem;
        background: #dfdfdf;
        opacity: 1;
        border-radius: 2px;
        color: #fff;
      }
    }
  }
  .detailPrice {
    margin-top: 1rem;
    width: 100%;
    padding: 0.4rem 4%;
    background-color: #fff;
    box-sizing: border-box;
    .price-top {
      display: flex;
      justify-content: space-between;
      .price-top-left {
        width: 80%;
        // height: 6rem;
        font-size: 1rem;
        text-align: left;
        font-family: PingFang SC;
        font-weight: bold;
        // line-height: 6rem;
        color: #333333;
        // letter-spacing: 100px;
        opacity: 1;
      }
      .price-top-right {
        display: flex;
        flex-wrap: wrap;
        width: 1.2rem;
        justify-content: space-between;
        align-items: center;
        width: 8%;
        img {
          width: 1.2rem;
          height: 1rem;
        }
      }
    }
    .price-center {
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        font-size: 0.6rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
      }
      .price {
        font-size: 1.2rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #ff9a26;
        opacity: 1;
      }
    }
  }
  .detailDec {
    margin-top: 1rem;
    background-color: #fff;
    padding: 1rem 4%;
    box-sizing: border-box;
    div {
      // width: 192px;
      // height: 17px;
      text-align: left;
      line-height: 1.5rem;
      height: 1.5rem;
      font-size: 0.8rem;
      font-family: PingFang SC;
      font-weight: bold;
      // font-weight: 400;
      line-height: 14px;
      color: #333333;
      opacity: 1;
    }
  }
  .detailRule {
    padding: 1.8rem 4%;
    height: 3rem;
    margin-top: 1rem;
    background-color: #fff;
    box-sizing: border-box;
    font-family: PingFang SC;
    font-weight: bold;
    display: flex;
    align-items: center;
    .rule {
      font-size: 1rem;
      line-height: 24px;
      color: #333333;
      opacity: 1;
      display: flex;
      justify-content: start;
      align-items: center;
      .cartgroy {
        margin-left: 1rem;
        span {
          color: rgba(255, 154, 38, 1);
        }
      }
      .ruleImg {
        width: 7rem;
        height: 2rem;
        margin-left: 9rem;
        display: flex;
        font-size: 0.8rem;
        justify-content: center;
        align-items: center;
        background: #ff9a26;
        border-radius: 1rem;
        span {
          display: inline-block;
          font-size: 0.8rem;
          font-family: PingFang SC;
          color: #ffffff;
          opacity: 1;
        }
        img {
          margin-left: 0.5rem;
          display: inline-block;
        }
      }
    }
  }
  .detailPhoto {
    margin-top: 1rem;
    background-color: #fff;
    padding: 1rem 4%;
    margin-bottom: 1.5rem;
    .photo-dec {
      height: 1.5rem;
      line-height: 1.5rem;
      text-align: left;
      font-size: 1rem;
      font-family: PingFang SC;
      font-weight: bold;

      color: #333333;
      opacity: 1;
    }
    ::v-deep img {
      width: 12rem;
      margin: 0 auto;
      // height: 200px;
    }
    // .photo-img {
    //   width: 100%;
    //   img {
    //     width: 80%;
    //   }
    // }
  }
  .joinCar {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 2.5rem;
    width: 100%;
    background: #ffffff;
    border: 1px solid #f5f1f1;
    opacity: 1;
    border-radius: 0px;
    display: flex;
    justify-content: start;
    align-items: center;
    .Car-left {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 30%;
      height: 100%;
      border-right: 1px solid rgba(112, 112, 112, 0.1);
      div {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        align-items: center;
      }
    }
    .Car-center {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 40%;
      padding: 0 1rem;
      box-sizing: border-box;
      // border-right: 1px solid #707070;
      /deep/ .el-input-number {
        width: 8rem;
        line-height: 2rem;
      }

      /deep/ .el-input-number__decrease {
        height: calc(2rem - 0px);
        line-height: calc(2rem - 0px);
        box-sizing: content-box;
        border-radius: 2px;
      }
      /deep/ .el-input-number__increase {
        height: calc(2rem - 0px);
        line-height: calc(2rem - 0px);
        box-sizing: content-box;
        border-radius: 2px;
      }
      /deep/ .el-input__inner {
        height: 2rem;
        line-height: 2rem;
        // border: none;
        border-radius: 0;
      }
      /deep/ .el-input {
        border: 1px solid #dcdfe6;
      }
    }
    .Car-right {
      width: 30%;
      height: 100%;
      color: #fff;
      font-size: 1rem;
      line-height: 2.5rem;
      background: #ff9a26;
      box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 0px;
    }
    /deep/ .el-input-number__decrease {
      height: 2rem;
      line-height: 2rem;
      box-sizing: content-box;
    }
    /deep/ .el-input-number__increase {
      height: 2rem;
      line-height: 2rem;
      box-sizing: content-box;
    }
    /deep/ .el-input__inner {
      height: 2rem;
      line-height: 2rem;
      border: none;
      border-radius: 0;
    }

    /deep/ .el-input__inner {
      height: 2rem;
      line-height: 2rem;
      border: none;
      border-radius: 0;
    }
  }
  .popup {
    padding: 0 4%;
    box-sizing: border-box;
    .popup-top {
      display: flex;
      justify-content: start;
      align-items: flex-start;
      padding: 1rem;
      .top-left {
        width: 6rem;
        height: 8rem;
        // background-color: red;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .top-right {
        // margin-left: 1rem;
        padding: 1rem;
        font-size: 1rem;
        text-align: left;
        line-height: 1.5rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        opacity: 1;
        .right2 {
          margin: 0.5rem 0;
          font-size: 1.5rem;
          color: #ff9a26;
        }
        .right3 {
          font-size: 0.8rem;
          color: #707070;
        }
      }
    }
    .popup-center {
      height: calc(100% - 14rem);
      .center-title {
        height: 2rem;
        line-height: 2rem;
        font-size: 1.3rem;
        text-align: left;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        opacity: 1;
      }
      .center-content {
        display: flex;
        flex-wrap: wrap;
        width: 100%;

        justify-content: space-between;
        align-items: center;

        .center-dec {
          margin: 0.2rem 0;
          width: 48%;

          background: #f8f8f8;
          border: 1px solid #d9d9d9;
          display: flex;
          justify-content: start;
          align-items: center;
          box-sizing: border-box;
          img {
            width: 2rem;
            max-height: 2rem;
            // height: 3rem;
          }
          span {
            margin-left: 0.3rem;
            font-size: 0.8rem;
            height: 2.8rem;
            line-height: 2.8rem;
            color: rgba(51, 51, 51, 1);
            width: 8rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .dec1 {
          border: 1px solid #f53d3d;
        }
      }
    }
    .popup-bottom {
      // width: 90%;
      // position: fixed;
      // left: 0;
      // bottom: 1rem;
      // margin-top: 5rem;
      margin-bottom: 1rem;
      width: 100%;
      div {
        box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.16);
        border-radius: 3%;
        width: 100%;
        font-family: PingFang SC;
        font-weight: bold;
        margin: 0 auto;
        height: 3rem;
        line-height: 3rem;
        font-size: 1.5rem;
        background: #ff9a26;
        color: #fff;
      }
    }
  }
}
</style>